function ensureBeginsWith(str, prefix) {
  if (!str) {
    return "";
  }
  return str.indexOf(prefix) === 0 ? str : prefix + str;
}
function stripPrefix(str, prefix) {
  return str.indexOf(prefix) === 0 ? str.slice(prefix.length) : str;
}
export { ensureBeginsWith, stripPrefix };